
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { ToastContainer } from "react-toastify";
import AboutBanner from "@/modules/frontend/components/About_Us/AboutBanner";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import Counter from "@/modules/frontend/components/Counter";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import AboutUsImg1 from "@/assets/images/webp/about-us-img-1.webp";
import AboutUsImg2 from "@/assets/images/webp/about-us-2.webp";
import AboutUsImg3 from "@/assets/images/webp/about-us-3.webp";

import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { Link } from "react-router-dom";


const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);


  const sectionRef = useRef(null);

  const [smallmodalShow, setSmallModalShow] = useState(false);

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  return (
    <section className="about-us-page-wrape">
      <SeoHelmet
        title={seoConfig.aboutUs.title}
        description={seoConfig.aboutUs.description}
        keywords={seoConfig.aboutUs.keywords}
        author={seoConfig.aboutUs.author}
      />

      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>

      <AboutBanner />

      {/* our story wrape START */}
      <section ref={sectionRef} className={`inner-page-content-wrape our-story-wrape`}>
        <div className="container">
          <div className="content-wrape mobile-show page-head">
            <h2 className="mobile-head-text">
              <motion.span
                className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Where </motion.span>
              <motion.span className="blue-text">Global </motion.span>
              <motion.span className="black">Businesses Connect</motion.span>
            </h2>
            <p>Fusing Innovation with Trust to Shape the Future of Global Trade Through Strong Partnerships</p>
          </div>
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6">
              <div className="img-wrape">
                <Link to={publicRoutePaths.REGISTRATION.path} href={publicRoutePaths.REGISTRATION.path} target="_blank">
                  <motion.img
                    src={AboutUsImg1}
                    alt='Global B2B Network'
                    loading="lazy"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                    className={`animate-child`}
                  >
                  </motion.img>
                </Link>

              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className={`head animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Our Story
                    </motion.h2>
                    <motion.h6 className={`varient animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Orex Trade World INC connects businesses across 80+ countries, helping them find reliable partners and explore new markets.
                    </motion.h6>

                  </div>
                  <motion.p className={`varient animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Founded in 2015, Orex Trade World Inc, a U.S. based company, has been transforming the way businesses connect, trade and grow by making global trade easier, smarter and more reliable.</motion.p>

                  <motion.p className={`varient animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Since our inception, we have connected companies across 80+ countries and six continents, helping them discover trusted partners, explore new markets and access the insights they need to succeed.</motion.p>

                  <motion.p className={`varient animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >At Orex Trade, our foundation is built on innovation, trust and service excellence. Whether you are a buyer searching for the right supplier, a seller aiming to expand globally or logistic partners connecting the businesses worldwide,  we are here to simplify your journey and support your success in international trade.</motion.p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* our story wrape END */}

      {/* about us stats wrape START */}
      <section className="statistics-wrape dark">
        <div ref={sectionRef} className={`inner-pad`}>
          <motion.div className={`statistics-content animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter end={6} duration={2} decimals={0} className="add-plus" /> millions
              </span>
              <p>
                Global Buyers
              </p>
            </div>
          </motion.div>
          <motion.div className={`statistics-content animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter end={13} duration={2} decimals={0} className="add-plus" /> millions
              </span>
              <p>
                Global Shipments
              </p>
            </div>
          </motion.div>
          <motion.div className={`statistics-content animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter end={27} duration={2} decimals={0} className="add-plus" /> thousands
              </span>
              <p>
                Global Suppliers
              </p>
            </div>
          </motion.div>
          <motion.div className={`statistics-content big animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter end={80} duration={2} className="add-plus" /> Countries
              </span>
              <p>
                Globally Serve
              </p>
            </div>
          </motion.div>
          <motion.div className={`statistics-content big animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter end={750} duration={2} className="add-plus" /> Global
              </span>
              <p>
                Logistic Partners
              </p>
            </div>
          </motion.div>
          <motion.div className={`statistics-content big animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter end={350} duration={2} className="add-plus" /> World Wide
              </span>
              <p>
                Cities & Ports Covered
              </p>
            </div>
          </motion.div>
          <motion.div className={`statistics-content big animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div>
              <span>
                <Counter prefix="$" end={100} duration={2} suffix="K" /> Up to
              </span>
              <p>
                Financial Protection
              </p>
            </div>
          </motion.div>
        </div>
      </section>
      {/* about us stats wrape END */}

      {/* gray wrape START */}
      <section className={`gray-wrape`}>
        <div className="container">
          <div className="row flex-row-reverse">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className={`img-wrape`}>
                <motion.img src={AboutUsImg2} alt='Our Vision' loading="lazy" className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant} >
                </motion.img>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className={`head aimate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Our Vision
                    </motion.h2>
                  </div>
                  <motion.p className={`head animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    At Orex Trade, our vision is to revolutionize the future of global trade by creating a seamless, secure and intelligent digital ecosystem where buyers, suppliers and logistics partners can connect, collaborate and grow together.</motion.p>

                  <motion.p className={`head animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    We aim to become the world’s most trusted global business network, bridging markets and industries across continents through innovation, transparency and efficiency. By simplifying complex trade and supply chain processes, we empower businesses of all sizes to access new markets, build lasting partnerships and achieve sustainable global growth.
                  </motion.p>

                  <motion.p className={`head animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Our vision goes beyond transactions, it’s about transforming how the world trades, fostering trust-driven relationships and making international commerce more accessible, inclusive and future-ready.
                  </motion.p>

                  <motion.p className={`head animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Orex Trade connecting opportunities, driving growth and shaping the future of global business.
                  </motion.p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* gray wrape END */}

      {/* our mission wrape START */}
      <section className={`our-mission-wrape`}>
        <div className="container">
          <div className="row ">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className={`img-wrape`}>
                {/* <img src={AboutUsImg3} alt='Our Mission' loading="lazy" /> */}
                <motion.img src={AboutUsImg3} alt='Our Mission' loading="lazy" className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className={`head animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Our Mission
                    </motion.h2>
                  </div>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    At Orex Trade, our mission is to bridge the global gap between buyers, suppliers and logistics partners by offering a trusted, technology-driven global business network that simplifies international commerce. We are dedicated to empowering businesses with powerful tools, actionable insights and advanced trade intelligence to help them make smarter, data-informed decisions.</motion.p>
                  <motion.p className={`animate-child`}
                    initial="hidden" z
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Through our verified global network, we aim to create a transparent, secure & collaborative environment where companies of all sizes can expand their market presence, explore new opportunities and build long-term, reliable partnerships.</motion.p>

                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Our mission is to not only connect businesses but to enable sustainable growth, strengthen trust in global trade and drive digital transformation across supply chains worldwide.</motion.p>

                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Orex Trade empowering businesses to trade smarter, grow faster and succeed globally.
                  </motion.p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* our mission wrape END */}

      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </section >
  );
}

export default React.memo(Index);